import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as superAdminActions from '../../ducks/super-admin'
import AccountCreation from '../AccountCreation'

class AccountCreationContainer extends React.Component {
  componentDidMount() {
    this.props.actions.fetchOrganisations()
  }

  render() {
    return (
      <AccountCreation
        organisations={this.props.organisations}
        onAdd={this.props.actions.addAccount}
        isSuperAdminView={true}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    organisations: state.superAdmin.get('organisations')
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(superAdminActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountCreationContainer)



// WEBPACK FOOTER //
// ./src/components/smart/AccountCreationContainer.js